<template>
	<div class="newsdetail">
		<div class="location">新闻详情</div>
		<div class="newsplay">
			<div class="newsTitle">{{news_title}}</div>
			<div class="newsCont" v-html="news_content"></div>
			<div class="newsTime">{{news_time}}</div>
			<div class="newsTime" style="margin-top: 10px !important;">{{news_puber}}</div>
		</div>
	</div>
</template>

<script>
	import { detail } from '@/axios';
	export default {
		data(){
			return{
				news_title:"数据加载中...",
				news_content:"数据加载中...",
				news_time:"数据加载中...",
				news_puber:"数据加载中..."
			}
		},
		methods: {
			// 获取数据
			getdata() {
				var that = this;
				detail.newDetail({
					id:that.$route.query.id
				}).then(res => {
					if(res.code == 200){
						that.news_title = res.data.title==""?'': res.data.title
						that.news_content = res.data.content==""?'': res.data.content
						that.news_time = res.data.pubtime==""?'': res.data.pubtime
						that.news_puber = res.data.pubuser==""?'': res.data.pubuser
					}
				})
			}
		},
		mounted(){
			var that = this;
			that.getdata();
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.newsdetail{
		width: $indexWidth;
		margin: 0 auto;
		.location{
			line-height: 60px;
			font-size: 16px;
			color: $indexColor1;
			width: 100%;
		}
		.newsplay{
			background: rgba($color: #000, $alpha: 0.03);
			width: 100%;
			padding: 40px 40px;
			box-sizing: border-box;
			.newsTitle{
				width: 100%;
				line-height: 50px;
				color: #bb0000;
				font-size: 24px;
				text-align: center;
				font-weight: bold;
			}
			.newsTime{
				font-size: 16px;
				text-align: right;
				width: 100%;
				color: #333;
				margin-top: 50px;
			}
			.newsCont{
				color: $indexColor1;
				font-size: 16px;
				padding-top: 20px;
				line-height: 30px;
				letter-spacing: 2px;
				p{
					width: 100%;
				}
				img{
					width: 70% !important;
					margin: 20px 0 20px 15%;
				}
			}
		}
	}
</style>
